import { render, staticRenderFns } from "./TenantActions.vue?vue&type=template&id=1af5513c&scoped=true"
import script from "./TenantActions.vue?vue&type=script&lang=js"
export * from "./TenantActions.vue?vue&type=script&lang=js"
import style0 from "./TenantActions.vue?vue&type=style&index=0&id=1af5513c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5513c",
  null
  
)

export default component.exports